import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_119: FaireProductEntity = {
  token: "starter_collection_119",
  type: "product",
  name: "Totem Glasses by Sophie Lou",
  brandName: "Ghia",
  imageUrl:
    "https://cdn.faire.com/fastly/4309982e62fbd510b21fea7ab6127ff1ff81b353c7bae48136dc7c7548e90c77.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 88,
  msrpDollars: 176,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
